import {Layout, Input} from '@di-nxt/components';
import React from 'react';
import {t} from '../../../localization';

type Props = {
  value: string | undefined;
  onChange: (value: string) => void;
};

export const Search: React.FC<Props> = ({value, onChange}) => {
  return (
    <Layout
      horizontal
      padding="20"
      borderBottomColor="border_mono_15"
      borderBottomWidth="1"
      borderBottomStyle="solid">
      <Input
        flex
        placeholder={t('screens.members.searchpeople')}
        value={value}
        onChange={onChange}
        leftIcon="search"
        rightIcon={value ? 'closeCircle' : undefined}
        rightIconFilled
        rightOnPress={value ? () => onChange('') : undefined}
      />
    </Layout>
  );
};
